import internalApiClient from '../api/internalApiClient';

export default async function getCityNameFromPostCode(postcode: string): Promise<string | null> {
    try {
        const url = `https://services.datafordeler.dk/DAR/DAR/1/REST/postnummer?postnr=${postcode}`;
        const city = await fetch(url).then(response => {
            if (response.status === 200) return response.json();
            return null;
        });
        return city?.[0]?.navn;
    } catch {
        return null;
    }
}

/**
 * Same signature as getCityNameFromPostCode but using internal API.
 *
 * @param {string} zipCode
 * @returns city name for the specified zipCode or undefined if unable to do so
 */
export async function getCityNameFromPostCodeInternal(zipCode: string) {
    try {
        const response = await internalApiClient.get(`zipcode/city/${zipCode}`);
        return response.data;
    } catch {}

    return undefined;
}
